var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrench = function SvgFrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "french_svg__a",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#653ED5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#french_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h9v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED2939",
    d: "M17 0h9v26h-9z"
  }))));
};
export default SvgFrench;